import React from "react";
import { useTranslation } from "react-i18next";
import { TbRectangle, TbCircle, TbTriangle, TbLine, TbPointFilled, TbTypography, TbAngle } from "react-icons/tb";
import { CanvasPrimitiveType } from "@ltypes/scene";
import { PRIMITIVE_TYPES, PRIMITIVE_LABEL_KEY } from "./primitives";

const ICONS: Record<CanvasPrimitiveType, React.ReactNode> = {
    text: <TbTypography size="1.5rem" />,
    rectangle: <TbRectangle size="1.5rem" />,
    circle: <TbCircle size="1.5rem" />,
    line: <TbLine size="1.5rem" />,
    triangle: <TbTriangle size="1.5rem" />,
    arc: <TbAngle size="1.5rem" />,
    pixel: <TbPointFilled size="1.5rem" />,
};

type ToolboxProps = {
    onAdd: (type: CanvasPrimitiveType) => void,
};

function Toolbox(props: ToolboxProps) {
    const { t } = useTranslation();

    const onDragStart = (e: React.DragEvent, type: CanvasPrimitiveType) => {
        e.dataTransfer.setData('application/x-lumeba-primitive', type);
        e.dataTransfer.effectAllowed = 'copy';
    };

    return (
        <div className="canvas-toolbox">
            {PRIMITIVE_TYPES.map((type) => (
                <button
                    key={type}
                    type="button"
                    className="canvas-toolbox-item"
                    draggable
                    onDragStart={(e) => onDragStart(e, type)}
                    onClick={() => props.onAdd(type)}
                    title={t(PRIMITIVE_LABEL_KEY[type])}
                >
                    <span className="canvas-toolbox-item-icon">{ICONS[type]}</span>
                    <span className="canvas-toolbox-item-label">{t(PRIMITIVE_LABEL_KEY[type])}</span>
                </button>
            ))}
        </div>
    );
}

export default Toolbox;
